/*
 * GLOBAL QUICK SEARCH
 *
 * Searches CRM accounts and contacts and routes a selected result to its detail page.
 *
 * Recent changes:
 * - Supports an explicit accessible label and compact input styling for the responsive navbar.
 */

import { useNavigate } from 'react-router';
import EntityTypeahead, { EntityTypeaheadResult } from '../common/EntityTypeahead';
import React from 'react';

interface QuickSearchProps {
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
  inputClassName?: string;
}

const QuickSearch: React.FC<QuickSearchProps> = ({
  placeholder = 'Search contacts and accounts...',
  ariaLabel = 'Search accounts and contacts',
  className = '',
  inputClassName = ''
}) => {
  const navigate = useNavigate();
  const handleSelect = async (result: EntityTypeaheadResult) => {
    try {
      // Handle Account selection
      if (result.type === 'Account' && result.id) {
        // await request(API_ENDPOINTS.POST_USER_ACCOUNT, { userId: currentUserId, id: result.id });
        navigate(`/accounts/${result.id}`, { replace: true });
        return;
      }

      // Handle Contact selection
      if (result.type === 'Contact') {
        // Navigate to existing contact
        if (result.id) {
          // await request(API_ENDPOINTS.POST_USER_CONTACT, { userId: currentUserId, id: result.id });
          navigate(`/contacts/${result.id}`, { replace: true });
          return;
        }

        // Create and navigate to new contact
        if (result.personId) {
          const newContact = { id: (result.personId + 99000000) };//await request(API_ENDPOINTS.PUT_CONTACT, { personId: result.personId });
          if (newContact?.id) {
            // await request(API_ENDPOINTS.POST_USER_CONTACT, { userId: currentUserId, id: newContact.id });
            navigate(`/contacts/${newContact.id}`, { replace: true });
          }
          return;
        }
      }
    } catch (err) {
      console.error('Error handling selection:', err);
    }
  };

  return (
    <EntityTypeahead
      onSelect={handleSelect}
      placeholder={placeholder}
      ariaLabel={ariaLabel}
      className={className}
      inputClassName={inputClassName}
    />
  );
};

export default QuickSearch;
